import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const commonRoutes = [
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录' },
    component: () => import('../components/Login.vue'),
  },
  {
    path: '/menu',
    name: 'menu',
    meta: { title: '登录' },
    component: () => import('../components/menu.vue'),
  },
  {
    path: '/404',
    name: '404',
    meta: { title: '404' },
    component: () => import('../components/404.vue'),
  },
  { path: '/', redirect: '/PPuser' },
]

// 本地所有的页面 需要配合后台返回的数据生成页面  management
export const asyncRoutes = {
  home: {
    path: 'home',
    name: 'home',
    meta: { title: '主页' },
    component: () => import('../views/Home.vue'),
  },
  Pmanagement: {
    path: 'Pmanagement',
    name: 'Pmanagement',
    meta: { title: '设备积分管理' },
    component: () => import('../views/Points/management.vue'),
  },
  toExamine: {
    path: 'toExamine',
    name: 'toExamine',
    meta: { title: '积分审核' },
    component: () => import('../views/Points/toExamine.vue'),
  },
  PPuser: {
    path: 'PPuser',
    name: 'PPuser',
    meta: { title: '用户管理' },
    component: () => import('../views/PPuser.vue'),
  },
  ArtificialServices: {
    path: 'ArtificialServices',
    name: 'ArtificialServices',
    meta: { title: '人工服务' },
    component: () => import('../views/ArtificialServices.vue'),
  },
  Gmanagement: {
    path: 'Gmanagement',
    name: 'Gmanagement',
    meta: { title: '礼品管理' },
    component: () => import('../views/Gift/management.vue'),
  },
  grant: {
    path: 'grant',
    name: 'grant',
    meta: { title: '礼品发放' },
    component: () => import('../views/Gift/grant.vue'),
  },
  banner: {
    path: 'banner',
    name: 'banner',
    meta: { title: 'banner管理' },
    component: () => import('../views/System/banner.vue'),
  },
  ProductLine: {
    path: 'ProductLine',
    name: 'ProductLine',
    meta: { title: '产品线管理' },
    component: () => import('../views/System/ProductLine.vue'),
  },
  GiftSpec: {
    path: 'GiftSpec',
    name: 'GiftSpec',
    meta: { title: '礼品规格管理' },
    component: () => import('../views/System/GiftSpec.vue'),
  },
  recommend: {
    path: 'recommend',
    name: 'recommend',
    meta: { title: '推荐位管理' },
    component: () => import('../views/System/recommend.vue'),
  },
  column: {
    path: 'column',
    name: 'column',
    meta: { title: '底页栏目' },
    component: () => import('../views/System/column.vue'),
  },
  footlist: {
    path: 'footlist',
    name: 'footlist',
    meta: { title: '底页链接管理' },
    component: () => import('../views/System/footlist.vue'),
  },
  RolePermissions: {
    path: 'RolePermissions',
    name: 'RolePermissions',
    meta: { title: '角色权限' },
    component: () => import('../views/System/RolePermissions.vue'),
  },
  staff: {
    path: 'staff',
    name: 'staff',
    meta: { title: '角色权限' },
    component: () => import('../views/System/staff.vue'),
  },
  agreement:{
    path: 'agreement',
    name: 'agreement',
    meta: { title: '协议权限' },
    component: () => import('../views/System/agreement.vue'),
  },
}

const createRouter = () => new Router({
  routes: commonRoutes,
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router